import React, { Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { Popconfirm } from "antd";
import {
  faPen,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";

import { requestGetNewsList } from "../../../actions/news/requests";
import useSearchHook from "../../../hooks/useSearch.hook";
import getFilesUrl from "../../../helpers/getFilesUrl";
import Filters from "./filters";
import EditModal from "./edit-modal";
import { deleteNews } from "./requests/deleteNew";

const News = (props) => {
  const {
    loading,
    list,
    getList,
    pages
  } = props;

  const {
    page,
    size,
    sort,
    filters,
    handlePageChange,
    handleSortedChange,
    handlePageSizeChange
  } = useSearchHook(getList, {
    size: 30,
    sort: "date,desc"
  });

  const reload = () => {
    getList(page, size, sort, filters);
  }

  const handleCreate = (data) => {
    const modalObj = {
      modalSettings: {
        size: "lg"
      },
      header: "City Modal",
      children: (
        <EditModal
          data={data || null}
          onCancel={() => props.closeCustomModal(modalObj)}
          onSuccess={() => {
            reload();
            props.closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => props.closeCustomModal(modalObj)
    };
    props.openCustomModal(modalObj);
  };

  const handleDelete = (id) => {
    deleteNews(id).then(() => {
      toast("News removed successfully", {
        type: toast.TYPE.SUCCESS,
      });
      reload();
    });
  };

  const findMainItem = (newsTranslations, key) => {
    if (!newsTranslations) {
      return false;
    }

    const result = newsTranslations.find(item => item.language === 'hy');
    if (!result || !result[key]) {
      return false;
    }
    return result[key];
  }

  const getColumns = () => [
    {
      Header: "#",
      accessor: "id",
    },
    {
      Header: "Active",
      accessor: "active",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className={original.active ? "text-success" : "text-danger"}>
          {original.active ? "Active" : "Inactive"}
        </div>
      )
    },
    {
      Header: "Title",
      Cell: ({ original }) => findMainItem(original.translations, "title"),
    },
    {
      Header: "Content",
      Cell: ({ original }) => findMainItem(original.translations, "content"),
    },
    {
      id: "photo",
      Header: "Photo",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        const img = findMainItem(original.translations, "image");
        return (
          img ? (
            <a href={getFilesUrl(img)} target="_blank" rel="noopener noreferrer">
              Photo
            </a>
          ) : "Image not exists"
        )
      },
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Fragment>
          <button
            className="btn btn-sm btn-primary mx-2"
            onClick={() => handleCreate(original)}
          >
            <FontAwesomeIcon icon={faPen}/>
          </button>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => handleDelete(original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger mx-2">
              <FontAwesomeIcon icon={faTimes}/>
            </button>
          </Popconfirm>
        </Fragment>
      ),
    }
  ];

  return (
    <div className="w-100 p-2">
      <div className="filters">
        <Filters
          activeFilters={[]}
          totalCount={false}
          handleCreate={handleCreate}
        />
      </div>
      <ReactTable
        data={list || []}
        headerClassName="table-header"
        columns={getColumns()}
        pageSizeOptions={[10, 20, 50, 100]}
        resizable
        className="-striped -highlight table-header-padding"
        loading={loading}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        style={{
          height: "calc(100vh - 140px)"
        }}
        manual={true}
        pages={pages}
        page={page}
        pageSize={size}
        onSortedChange={handleSortedChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.news.loading,
  list: state.news.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(requestGetNewsList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(News);



// WEBPACK FOOTER //
// ./src/views/pages/news/index.js